<template>
    <div>
        <h1 class="text-h5 my-5">
            Overview
            <v-progress-circular v-if="loading" indeterminate color="green" class="ml-3"/>
        </h1>

        <v-tabs height="40" show-arrows slider-size="2" class="mb-3">
            <template v-for="(name, id) in views">
                <v-tab v-if="name" :to="{params: {view: id === 'health' ? undefined : id}, query: $api.contextQuery()}" exact-path>
                    {{ name }}
                </v-tab>
            </template>
        </v-tabs>

        <template v-if="!view">
            <Health v-if="health" :applications="health" :categoriesTo="{name: 'workspace_settings', params: {tab: 'categories'}}" />
            <NoData v-else-if="!loading" />
        </template>

        <template v-else-if="view === 'map'">
            <ServiceMap v-if="map" :applications="map" :categoriesTo="{name: 'workspace_settings', params: {tab: 'categories'}}" />
            <NoData v-else-if="!loading" />
        </template>

        <template v-else-if="view === 'nodes'">
            <Table v-if="nodes && nodes.rows" :header="nodes.header" :rows="nodes.rows" />
            <NoData v-else-if="!loading" />
        </template>

        <template v-else-if="view === 'deployments'">
            <Deployments v-if="deployments" :deployments="deployments" :categoriesTo="{name: 'workspace_settings', params: {tab: 'categories'}}" />
            <NoData v-else-if="!loading" />
        </template>

        <template v-else-if="view === 'traces'">
            <Traces v-if="traces" :view="traces" :loading="loading" class="mt-5" />
            <NoData v-else-if="!loading" />
        </template>

        <template v-else-if="view === 'costs'">
            <NodesCosts v-if="costs && costs.nodes" :nodes="costs.nodes" class="mt-5" />
            <ApplicationsCosts v-if="costs && costs.applications" :applications="costs.applications" class="mt-5" />
        </template>
    </div>
</template>

<script>
import NoData from "@coroot/coroot/src/components/NoData.vue";
import ServiceMap from "@coroot/coroot/src/components/ServiceMap.vue";
import Table from "@coroot/coroot/src/components/Table.vue";
import NodesCosts from "@coroot/coroot/src/components/NodesCosts.vue";
import ApplicationsCosts from "@coroot/coroot/src/components/ApplicationsCosts.vue";
import Deployments from "@coroot/coroot/src/views/Deployments.vue";
import Health from "@coroot/coroot/src/views/Health.vue";
import Traces from "@coroot/coroot/src/views/Traces.vue";

export default {
    props: {
        workspaceId: String,
        projectId: String,
        view: String,
    },

    components: {NoData, ServiceMap, Table, NodesCosts, ApplicationsCosts, Deployments, Health, Traces},

    data() {
        return {
            health: null,
            map: null,
            nodes: null,
            costs: null,
            traces: null,
            deployments: null,
            sloReport: null,
            loading: false,
        };
    },

    watch: {
        view() {
            this.get();
        },
        $route(curr, prev) {
            if (curr.query.from === prev.query.from && curr.query.to === prev.query.to && curr.query.query !== prev.query.query) {
                this.get();
            }
        },
    },

    mounted() {
        this.get();
        this.$events.watch(this, this.get, 'refresh');
    },

    computed: {
        views() {
            return {
                health: 'Health',
                map: 'Service Map',
                traces: 'Traces',
                nodes: 'Nodes',
                deployments: 'Deployments',
                costs: this.costs ? 'Costs' : '',
            }
        }
    },

    methods: {
        get() {
            const view = this.view || 'health';
            const query = this.$route.query.query || '';
            this.loading = true;
            this.$api.getOverview(view, query, (data, meta) => {
                this.loading = false;
                if (!data) {
                    data = {};
                }
                this.health = data.health;
                this.map = data.map;
                this.nodes = data.nodes;
                this.traces = data.traces;
                this.costs = data.costs;
                this.deployments = data.deployments;
                if (!this.views[view]) {
                    this.$router.replace({params: {view: undefined}}).catch(err => err);
                }
            });
        },
    },
};

</script>

<style scoped>
</style>
